module.exports = __webpack_public_path__ + "static/media/3.b53525b4.jpg";